<template>
  <div id="guide-progress">
    <div class="guide-steps">
      <div v-for="(step, index) in steps" :key="index">
        <div class="step" :class="[step.name === currentStep.name ? 'isCurrentStep' : 'isOtherStep', stepStarted(index) ? 'clickable stepStarted' : '', step.checked ? 'checked':'']"
             @click="changeStep(index)"
        >

          <i class="fad fa-check-circle" style="--fa-secondary-opacity: 1.0;"
             :style="step.name === currentStep.name?
             '--fa-secondary-color: var(--goalBackgroundColor3);--fa-primary-color: var(--goalBackgroundColor);':
             '--fa-secondary-color: var(--goalBackgroundColor); --fa-primary-color: var(--goalBackgroundColor3);'"
             v-if="step.checked && !isMobile"></i>
          <i class="fas fa-dot-circle" v-else-if="!isMobile"></i>
          {{ step.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
name: "guide-progress",

  props: {
    currentStep: Object,
    steps: Array
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },

  methods: {
    changeStep: function(stepIndex) {
      if(stepIndex > 0) {
        if(this.steps[stepIndex-1].checked) {
          this.$emit('stepBack', stepIndex)
        }
      }
      else {
        this.$emit('stepBack', stepIndex)
      }

    },

    stepStarted: function(index) {
      if(index > 0) {
        if(this.steps[index-1].checked) {
          return true
        }
        else {
          return false
        }
      }
      else {
        return true
      }
    }
  },

  data() {
    return {

    }
  }
}
</script>

<style scoped>
#guide-progress {
  height: calc(100% - 4vw);
  width: calc(100% - 4vw);
  align-content: flex-start;
  background-color: hsla(220, 60%,70%,0.09);
  color: var(--goalBackgroundColor3);
  display: grid;
  margin: 2vw;
  border-radius: 1vw;
  grid-template-rows: repeat(5, auto) 1fr auto;
  overflow: hidden;
}

.guide-steps {
  display: flex;
  flex-direction: column;
}

.step {
  width: calc(100% - 2vw);
  height: min-content;
  font-size: 1.2vw;
  align-content: center;
  align-items: center;
  justify-self: flex-end;
  display: grid;
  grid-template-columns: 2.5vw auto 1fr;
  justify-items: center;
  padding: 1vw;
}

.isOtherStep {

  color: #ffffff33;
}

.isOtherStep:hover{
  background-color: #ffffff11;
}

.checked{
  color: var(--goalBackgroundColor3);
}

.isCurrentStep{
  background-color: var(--goalBackgroundColor);
  /*border-left: 0.5vw solid var(--goalBackgroundColor2);
  padding-left: 0.5vw;*/
}
.isCurrentStep:hover{
  background-color: var(--goalBackgroundColor);
}

@media screen and (max-device-width: 767px) {
  #guide-progress {
    height: 6vh;
    width: 100vw;
    align-content: flex-start;
    background-color: hsla(220, 60%,70%,0.09);
    color: var(--goalBackgroundColor3);
    display: grid;
    margin: 0vw;
    border-radius: 0vw;
    grid-template-rows: 1fr;
    grid-template-columns: repeat(5, auto) 1fr auto;
    overflow: hidden;
  }

  .guide-steps {
    display: flex;
    flex-direction: row;
    text-align: center;
  }

  .step {
    width: calc(100% - 2vw);
    height: 100%;
    font-size: 2.7vw;
    align-content: center;
    align-items: center;
    justify-self: flex-end;
    display: grid;
    grid-template-columns:  1fr;
    justify-items: center;
    padding: 0vw;
  }
}




</style>